var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYtdScore = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 26.6V29.4H20.6V26.6H23.4ZM29 26.6V29.4H26.2V26.6H29ZM34.6 26.6V29.4H31.8V26.6H34.6ZM37.4 16.8C38.1426 16.8 38.8548 17.095 39.3799 17.6201C39.905 18.1452 40.2 18.8574 40.2 19.6V39.2C40.2 39.9426 39.905 40.6548 39.3799 41.1799C38.8548 41.705 38.1426 42 37.4 42H17.8C17.0574 42 16.3452 41.705 15.8201 41.1799C15.295 40.6548 15 39.9426 15 39.2V19.6C15 18.8574 15.295 18.1452 15.8201 17.6201C16.3452 17.095 17.0574 16.8 17.8 16.8H19.2V14H22V16.8H33.2V14H36V16.8H37.4ZM37.4 39.2V23.8H17.8V39.2H37.4ZM23.4 32.2V35H20.6V32.2H23.4ZM29 32.2V35H26.2V32.2H29ZM34.6 32.2V35H31.8V32.2H34.6Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYtdScore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ytd_score.466e74bbec647b8444f2c7ebea69b327.svg";